// Trang chi tiết mission
import React, { useState, useEffect } from "react";
import { Box, Typography, Breadcrumbs } from "@mui/material";
import MissionDetail from "../../components/MissionDetail";
import { Contest } from "../../../../api/contest";
import { useAlert } from "@/contexts/AlertContext";
import {useParams, Link, useNavigate} from 'react-router-dom';

const MissionDetailPage = () => {
  const [missionDetail, setMissionDetail] = useState(null);
  const alert = useAlert();
  const navigate = useNavigate();
  const { contestId, missionId } = useParams();

  useEffect(() => {
    if (contestId && missionId) {
      fetchData();
    }
  }, [contestId, missionId]);

  const fetchData = async () => {
    try {
      alert.showWait();
      const [missionResponse, contestResponse] = await Promise.all([
        Contest.getMissionHistory(Number(missionId)),
      ]);
      setMissionDetail(missionResponse);
    } catch (error) {
      console.error("Error loading mission detail:", error);
      alert.error("Error loading mission detail");
    } finally {
      alert.hideWait();
    }
  };
  const handleBack = () => {
    navigate(`/student-workspace/my-contests/${contestId}`);
  };

  if (!missionDetail) return null;

  return (
    <Box>
      <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 1 }}>
        <MissionDetail
          data={missionDetail}
          onBack={handleBack}
        />
      </Box>
    </Box>
  );
};

export default MissionDetailPage; 